import { Action } from '@ngrx/store';
import { ErrorResponse, SeoContent } from '~shared/models';

export enum PlpSeoActionTypes {
    LOAD_PLP_SEO_CONTENT = '[Catalog] SeoContent Load',
    LOAD_PLP_SEO_CONTENT_SUCCESS = '[Catalog] SeoContent Load Success',
    LOAD_PLP_SEO_CONTENT_FAILURE = '[Catalog] SeoContent Load Failure'
}

export class LoadPlpSeoContent implements Action {
    readonly type = PlpSeoActionTypes.LOAD_PLP_SEO_CONTENT;

    constructor(public payload: { categoryId: string }) {}
}

export class LoadPlpSeoContentSuccess implements Action {
    readonly type = PlpSeoActionTypes.LOAD_PLP_SEO_CONTENT_SUCCESS;

    constructor(public payload: { plpSEOContent: SeoContent } ) {
    }
}

export class LoadPlpSeoContentFailure implements Action {
    readonly type = PlpSeoActionTypes.LOAD_PLP_SEO_CONTENT_FAILURE;

    constructor(public payload: { error: ErrorResponse }) {
    }
}

export type PlpSeoActionsUnion = LoadPlpSeoContent
| LoadPlpSeoContentSuccess
| LoadPlpSeoContentFailure;
